<template>
  <section class="book-grid-section">
    <div class="container">
      <div class="row g-4">
        <div
          v-for="(bookWrapper, index) in bookList"
          :key="index"
          class="col-12 col-md-6 col-xl-4"
        >
          <div class="book-card">
            <router-link
              :to="'/book/' + bookWrapper.book._id"
              style="text-decoration: none"
            >
              <img
                :src="
                  bookWrapper.book.images?.length ? `${BASE_IMAGE_PREFIX}/${bookWrapper.book.images[0]}` : 'https://libreture.com/static/images/book-placeholder.png'"
                :alt="bookWrapper.book.title"
                class="book-image"
              />
            </router-link>
            <div class="book-details">
              <router-link
                :to="'/book/' + bookWrapper.book._id"
                style="text-decoration: none"
              >
                <h3 class="book-title">{{ bookWrapper.book.title }}</h3>
              </router-link>
              <router-link
                v-if="bookWrapper.book.productCategory !== 'stationary'"
                :to="'/search/?a=' + bookWrapper.book.author.replace(/ /g, '_')"
                style="text-decoration: none"
              >
                <div class="book-author">{{ bookWrapper.book.author }}</div>
              </router-link>
              <div class="book-price" v-if="bookWrapper.book.minVariant">
                <span v-if="bookWrapper.book.minVariant.salePrice">
                  <span class="text-decoration-line-through text-muted me-1">
                    ৳ {{ bookWrapper.book.minVariant.price }}
                  </span>
                  <span>
                    ৳ {{ bookWrapper.book.minVariant.salePrice }}
                  </span>
                </span>

                <span v-else>
                  ৳ {{ bookWrapper.book.minVariant.price }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { BASE_IMAGE_PREFIX } from '@/globals';

export default {
  name: "ProductGridSection",
  props: {
    bookList: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      BASE_IMAGE_PREFIX,
    }
  },
};
</script>

<style lang="scss" scoped>
.book-grid-section {
  padding: 40px 0;
  background-color: #fff;

  .book-card {
    display: flex;
    border-bottom: 1px solid #e3e3e3;
    padding-bottom: 20px;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-5px);
    }

    .book-image {
      width: 120px;
      height: 150px;
      overflow: hidden;
      border-radius: 8px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .book-details {
      padding-left: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .book-title {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 5px;
        color: #333;
      }

      .book-author {
        color: #888;
        font-size: 14px;
        margin-bottom: 8px;
      }

      .book-price {
        color: #e61e25;
        font-size: 18px;
        font-weight: 600;
      }
    }
  }
}
</style>
